import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";

/**
 * @function RouteChangeContext
 * @description Contexto de rota de mudança
 * @returns {Object} - Contexto de rota de mudança
 */
export const RouteChangeContext = createContext({});

/**
 * @function RouteChangeProvider
 * @description Provider para controle de loading de rota
 * @param {Object} children - Componentes filhos
 * @returns {JSX.Element} - Provider de rota de mudança
 */
export const RouteChangeProvider = ({ children }) => {
    const [isLoading, setIsLoading] = useState(false);
    const location = useLocation();

    useEffect(() => {
        setIsLoading(true);
    }, [location.pathname]);

    const value = useMemo(() => ({
        isLoading,
        setIsLoading,
    }), [isLoading]);

    return (
        <RouteChangeContext.Provider value={value}>
            {children}
        </RouteChangeContext.Provider>
    );
};

/**
 * @function useRouteChange
 * @description Hook para uso do contexto de rota de mudança
 * @returns {Object} - Contexto de rota de mudança
 */
export const useRouteChange = () => {
    return useContext(RouteChangeContext);
};
